import styles from './index.module.scss';

import ElocalIcon from 'svgs/elocal-logo-white.svg';
import EnergyStarIcon from 'svgs/energy-star.svg';
import VerifiedIcon from 'svgs/verified.svg';

import { FC } from 'react';

export const Badges: FC = () => (
  <div className={styles['badges-container']}>
    <EnergyStarIcon className={styles['energy-star']} />
    <div className={styles['elocal-verified-container']}>
      <ElocalIcon className={styles['elocal']} />
      <VerifiedIcon className={styles['verified']} />
    </div>
  </div>
);
